import initialState from './initialState';
import {
  POST_SUBMISSION_INFO,
  CONFIRM_SUBMISSION_INFO,
  SUBMISSION_INFO_LOADING,
  POST_SUBMISSION_ATTACHMENTS,
  CONFIRM_SUBMISSION_ATTACHMENTS,
  CLEAR_SUBMISSION_ATTACHMENTS,
  SET_SUBMISSION_INFO_FORM_SECTION_DATA,
  SET_FILES_TO_BE_UPLOADED
} from '../actions/actionTypes';

export default function submissionInfo(state = initialState.submissionInfo, action) {
  let newState;
  switch (action.type) {
    case POST_SUBMISSION_INFO:
      return action;
    case CONFIRM_SUBMISSION_INFO:
      return {
        ...state,
        submission: {
          isLoading: false,
          info: action.info,
          success: !!action.info.id,
        }
      };
    case SUBMISSION_INFO_LOADING:
      return {
        ...state,
        submission: {
          ...state.submission,
          isLoading: action.isLoading
        }
      };
    case POST_SUBMISSION_ATTACHMENTS:
      return action;
    case CONFIRM_SUBMISSION_ATTACHMENTS:
      newState = { ...state };
      if (typeof(action.status) !== 'undefined') {
        const status = action.status === 202;
        newState.statusOfCurrentAttachments = [...state.statusOfCurrentAttachments, status];
        newState.allFilesUploaded =
          newState.statusOfCurrentAttachments.length === (state.form.files.length) &&
          !newState.statusOfCurrentAttachments.includes(false);
      }
      return newState;
    case CLEAR_SUBMISSION_ATTACHMENTS:
      return { ...state, statusOfCurrentAttachments: [] };
    case SET_SUBMISSION_INFO_FORM_SECTION_DATA:
      return {
        ...state,
        form: {
          ...state.form,
          name: action.name,
          section: action.section,
        }
      };
    case SET_FILES_TO_BE_UPLOADED:
      return {
        ...state,
        form: {
          ...state.form,
          files: action.files
        }
      };
    default:
      return state;
  }
}
